import React from 'react';
import { Wrapper, Container } from './style';
import { Toast } from 'antd-mobile';
import { postCard,get } from '../../utils/request';
import Config from '../../config';

class Account2 extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      typeList: [
        {name: '银行卡',value: '1'},
        {name: '支付宝',value: '2'}
      ],
      typeValue: null,
      form: {
        accountName: '',
        idCard: '',
        accountNo: '',
        bankName: '',
        bankBranchName: '',
        zfbNo: ''
      }
    }
  }
  async componentDidMount() {
    document.title = '提现账户'
    this.loadInfo()
  }
  async loadInfo(){
    let params = {}
    let res = await get(`/pgy/user/${Config.appId}/home`, params)
    res = res.data.data
    console.log(res)
    if(res.bankInfo.paymentType){
      if(res.bankInfo.paymentType == 1){
        let form = {
          accountName: res.bankInfo.accountName,
          idCard: res.bankInfo.idCard,
          accountNo: res.bankInfo.accountNo,
          bankName: res.bankInfo.bankName,
          bankBranchName:  res.bankInfo.bankBranchName,
          zfbNo: ''
        }
        this.form = form
        this.setState({form, typeValue: 1})
      } else if (res.bankInfo.paymentType == 2){
        let form = {
          accountName: res.bankInfo.accountName,
          idCard: '',
          accountNo: '',
          bankName: '',
          bankBranchName: '',
          zfbNo: res.bankInfo.accountNo
        }
        this.form = form
        this.setState({form, typeValue: 2})
      }
    }
  }
  clickType(index){
    let typeValue = this.state.typeList[index].value
    this.setState({typeValue})
  }
  bindInput(key, e){
    let value = e.target.value
    // if(boolean == 'phone'){
    //   if(value.length > 11){
    //     value = value.slice(0,11)
    //   }
    // }
    let form = this.state.form
    form[key] = value
    this.setState({form})
  }
  async submit(){
    let typeValue = this.state.typeValue
    let form = this.state.form
    let params = {}
    if(typeValue == 1){
      if(!form.accountName){
        Toast.info('请输入开户姓名')
        return false
      }
      if(!form.idCard){
        Toast.info('请输入身份证号')
        return false
      }
      if(!form.accountNo){
        Toast.info('请输入银行账号')
        return false
      }
      if(!form.bankName){
        Toast.info('请输入开户银行')
        return false
      }
      if(!form.bankBranchName){
        Toast.info('请输入开户支行')
        return false
      }
      params.accountName = form.accountName
      params.idCard = form.idCard
      params.accountNo = form.accountNo
      params.bankName = form.bankName
      params.bankBranchName = form.bankBranchName
      params.paymentType = 1
    } else if(typeValue == 2){
      if(!form.accountName){
        Toast.info('请输入开户姓名')
        return false
      }
      if(!form.zfbNo){
        Toast.info('请输入支付宝账户')
        return false
      }
      params.accountName = form.accountName
      params.accountNo = form.zfbNo
      params.paymentType = 2
    }
    Toast.loading('正在提交', 10)
    let res = await postCard(`/pgy/user/${Config.appId}/updateBankInfo`, params)
    Toast.hide()
    if(res.data.code == 100){
      Toast.info('提交成功')
      this.props.history.push(`/list`)
    } else {
      Toast.info(res.data.msg)
    }
  }
  render() {
    let { typeList,typeValue,form } = this.state;
    return (
      <Wrapper>
        <Container>
        <div className="list">
          {typeList.map((v, i) => (
            <div className="item" key={`typeList-key-${i}`} onClick={() => this.clickType(i)}>
              <i className={`${typeValue==v.value?'active':''}`}><b></b></i>
              <span>{v.name}</span>        
            </div>
          ))}
        </div>
        {typeValue==1&&(
          <>
            <div className="title">请填写本人银行<span>储蓄卡</span>信息，用于支付您的佣金</div>
            <div className="form">
              <div className="item">
                <label>开户姓名</label>
                <input placeholder="请输入开户姓名" value={form.accountName} maxLength="99" onChange={e => this.bindInput('accountName', e)}></input>
              </div>
              <div className="item">
                <label>身份证号</label>
                <input placeholder="请输入身份证号" value={form.idCard} maxLength="99" onChange={e => this.bindInput('idCard', e)}></input>
              </div>
            </div>
            <div className="form form2">
              <div className="item">
                <label>银行账号</label>
                <input placeholder="请输入银行账号" value={form.accountNo} maxLength="99" onChange={e => this.bindInput('accountNo', e)}></input>
              </div>
              <div className="item">
                <label>开户银行</label>
                <input placeholder="请输入开户银行" value={form.bankName} maxLength="99" onChange={e => this.bindInput('bankName', e)}></input>
              </div>
              <div className="item">
                <label>开户支行</label>
                <input placeholder="请输入开户支行" value={form.bankBranchName} maxLength="99" onChange={e => this.bindInput('bankBranchName', e)}></input>
              </div> 
            </div>
          </>
        )}
        {typeValue==2&&(
          <>
            <div className="title">请填写本人银行<span>支付宝</span>信息，用于支付您的佣金</div>
            <div className="form">
              <div className="item">
                <label>开户姓名</label>
                <input placeholder="请输入开户姓名" value={form.accountName} maxLength="99" onChange={e => this.bindInput('accountName', e)}></input>
              </div>
              <div className="item">
                <label>支付宝账户</label>
                <input placeholder="支付宝／手机号" value={form.zfbNo} maxLength="99" onChange={e => this.bindInput('zfbNo', e)}></input>
              </div>
            </div>
          </>
        )}
        {typeValue&&(
          <div className="btns">
            <div className="btn" onClick={() => this.submit()}>保存</div>
          </div>
        )}
        </Container>
      </Wrapper>
    );
  }
}
export default Account2;